import React, { useState, useEffect, useRef } from 'react';
import { Col, Row, Modal, Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt, faCircleXmark, faTrash } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';
import { toast } from 'react-toastify';
import * as mammoth from 'mammoth';

import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';

import MessageBox from '../../../../Components/common/MessageBox';
import Docmnt from '../../../../assets/images/google-docs.png';

const CreateDoc = ({ sendData, onclose, onSave, modalFrom, srId, createPos, details_doc }) => {

    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(false);
    const [createModal, setCreateModal] = useState(true);
    const initFdata = {
        // publish_for: 'departments',
        is_publish: 0,
        // docName: '',
        version: '',
        department_id: [],
        template_id: '',
    }
    const [formData, setFormData] = useState(sendData || initFdata);
    const [imageOptions, setImageOptions] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    const [templateData, setTemplateData] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [readSignType, setReadSignType] = useState([]);
    const [awbList, setAwbList] = useState([]);

    const fetchAwb = async () => {
        try {
            const res = await withRFSToken.post("service-recovery/all-awb-number?tab=document")
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformData = innerData ? innerData.map((item) => ({
                        label: item.master_airway_bill,
                        value: item.documentable_id,
                        documentable_type: item.documentable_type
                    })) : []
                    setAwbList(transformData)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchReadSign = async () => {
        try {
            const res = await withRFSToken.post('get-meta-list', { type_id: 21 })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setReadSignType(innerData)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchImage = async () => {
        try {
            const res = await withRFSToken.get("/file-management/list")
                .then(function (res) {
                    const data = res.data.Rows;

                    const transformData = data?.map(item => ({
                        label: item.file_name,
                        value: item.id,
                        imageUrl: `${item.file_path}`
                    })) || [];
                    setImageOptions(transformData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchdeparrtment = async () => {
        try {
            const res = await withRFSToken.get("/organisation-department/dropdown")
                .then(function (res) {
                    if (res.data.response_code === 200) {
                        const innerData = res.data.response_data;

                        const transformData = innerData ? innerData.map((item) => ({
                            label: item.label,
                            value: item.value
                        })) : []
                        setDepartmentList(transformData)
                    }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetctemplatehData = async () => {
        try {
            const res = await withRFSToken.get('template/dropdown?tab=document')
            if (res.data.response_code === 200) {
                const innerData = res.data.response_data;
                // const transformData = innerData ? innerData.map((item) => ({
                //   label: item.label,
                //   value: item.value
                // })) : []
                setTemplateData(innerData)
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (isMounted.current) return;

        fetchImage();
        fetchdeparrtment();
        fetctemplatehData();
        fetchAwb();
        fetchReadSign();
        // localStorage.removeItem('RS')
        isMounted.current = true;
    }, []);

    const handleChange = (field, value) => {
        console.log('value', value);

        setFormData(prev => {
            let updated = { ...prev, [field]: value };

            const removeFields = (fields) => {
                fields.forEach(f => delete updated[f]);
            };

            if (field === "is_publish") {
                if (value === 1) {
                    updated = {
                        ...updated,
                        requires_login: 1,
                        announcement: 0,
                        read_and_sign: 1,
                        publish_for: 'departments',
                    };
                } else if (value === 0) {
                    removeFields(["requires_login", "announcement", "read_and_sign", "read_sign_type", "publish_for", "department", "publishLink"]);
                }
            }

            if (field === "announcement") {
                if (value === 1) {
                    removeFields(["read_and_sign", "read_sign_type"]);
                    updated.announcement_days = 30;
                } else if (value === 0) {
                    updated.read_and_sign = 1;
                    updated.read_sign_type = null;
                }
            }

            if (field === "publish_for") {
                if (value === "private") {
                    removeFields(["read_sign_type"]);
                    updated.read_and_sign = 0;
                } else {
                    updated.read_and_sign = 1;
                    updated.read_sign_type = null;
                }
            }

            return updated;
        });
    };

    //-------------------- for image section-------->

    const [files, setFiles] = useState([]);
    const [base64Files, setBase64Files] = useState([]);
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [editFiles, setEditFiles] = useState([]);
    const [isTopDel, setIsTopDel] = useState(false);

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);

    };
    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    const fileInputRef = useRef(null);
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        console.log('selectedFiles', selectedFiles);
        const filesWithBase64 = [];
        let filesProcessed = 0;

        // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
        const existingBase64Files = formData?.base64Files || [];
        const existingFiles = formData?.files || [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
                filesProcessed += 1;
                if (filesProcessed === selectedFiles.length) {
                    const newFiles = filesWithBase64.map((obj) => obj.file);
                    // const newBase64Files = filesWithBase64.map((obj) => obj.base64);
                    const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    const mergedBase64Files = [...existingBase64Files, ...newBase64Files];
                    const mergedFiles = [...existingFiles, ...newBase64Files];
                    // setFiles(newFiles);
                    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
                    setBase64Files(mergedBase64Files);
                    setFormData((prevFormData) => {
                        // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
                        const newFormData = { ...prevFormData, files: mergedFiles, base64Files: mergedBase64Files };

                        return newFormData;
                    });
                }
            };
            reader.readAsDataURL(file);
        });
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const handleImageSelect = (key, data) => {
        // console.log("🚀 ~ handleImageSelect ~ data:", data)

        if (formData.files) {
            const extension = data?.name?.split('.').pop().toLowerCase();
            if (["jpeg", "jpg", "png", "webp"].includes(extension)) {
                setFormData((prevFormData) => {
                    const updatedFiles = prevFormData.files.map((file, index) => {
                        if (index === key) {
                            // Toggle the "primary" field for the selected file
                            return {
                                ...file,
                                primary: file.primary === 1 ? 0 : 1,
                            };
                        }
                        return file;
                    });

                    return {
                        ...prevFormData,
                        files: updatedFiles,
                    };
                });

                setSelectedKeys((prevSelected) =>
                    prevSelected.includes(key)
                        ? prevSelected.filter((selectedKey) => selectedKey !== key) // Remove key if already selected
                        : [...prevSelected, key] // Add key if not selected
                );
            }
        }
        if (["jpeg", "jpg", "png", "webp"].includes(data?.file_type)) {

            setEditFiles((prevFiles) =>
                prevFiles.map((file) =>
                    file.id === data.id
                        ? { ...file, primary: file.primary === 1 ? 0 : 1 } // Toggle primary between 1 and 0
                        : file // Leave other files unchanged
                )
            );
        }

    };

    const handleDeleteFile = (index, id, type) => {
        if (isTopDel) {
            setEditFiles((prevFiles) => {
                const newFiles = [...prevFiles];
                newFiles.splice(index, 1);
                return newFiles;
            });
        } else {
            setFiles((prevFiles) => {
                const newFiles = [...prevFiles];
                newFiles.splice(index, 1);
                return newFiles;
            });
            // base64Files.splice(index, 1);
            setBase64Files((prevBase64Files) => {
                const newBase64Files = [...prevBase64Files];
                newBase64Files.splice(index, 1);

                // Update local storage
                setFormData((prevFormData) => {
                    const newFormData = { ...prevFormData, base64Files: newBase64Files };
                    return newFormData;
                });

                return newBase64Files;
            });
        }

    };

    //<---------------------end---------------------------->

    //<------------------------convert file dox and pdf--------------------->
    const [selectedFile, setSelectedFile] = useState(null);
    const [extractedText, setExtractedText] = useState('');

    const [error, setError] = useState('');
    const [copied, setCopied] = useState(false);
    const fileInputRef1 = useRef(null);

    const handleBrowseFiles1 = (e) => {
        e.preventDefault();
        fileInputRef1.current.click();
    };

    const handleFileSelect = (event) => {
        const file = event.target.files[0];

        const isValidFile = (
            file?.type === 'application/pdf' ||
            file?.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
            file?.type === 'application/msword' ||
            file?.name.toLowerCase().endsWith('.doc') ||
            file?.name.toLowerCase().endsWith('.docx') || ''
        );

        if (file && isValidFile) {
            setSelectedFile(file);
            setError('');
            setExtractedText('');
        } else {
            setError('Please select a valid PDF, DOC, or DOCX file');
            setSelectedFile(null);
        }
    };

    const convertDocumentToText = async () => {
        if (!selectedFile) return;

        // setIsLoading(true);
        setError('');
        setExtractedText('');

        try {
            const fileExtension = selectedFile.name.toLowerCase().split('.').pop();
            let extractedContent = '';

            if (fileExtension === 'pdf') {
                extractedContent = await convertPdfToHtml();
            } else if (fileExtension === 'doc' || fileExtension === 'docx') {
                extractedContent = await convertWordToHtml();
            }

            if (extractedContent.trim()) {
                setExtractedText(extractedContent.trim());
                setFormData(prev => ({
                    ...prev,
                    content: extractedContent.trim()
                }));
            } else {
                setError('No content found in the document. The file might contain only images or be password protected.');
            }

        } catch (err) {
            setError(`Error converting document: ${err.message}`);
        } finally {
            setIsLoading(false);
        }
    };

    const convertPdfToHtml = async () => {
        let pdfjsLib = window.pdfjsLib;

        if (!pdfjsLib) {
            await new Promise((resolve, reject) => {
                const script = document.createElement("script");
                script.src = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js";
                script.onload = () => {
                    window.pdfjsLib.GlobalWorkerOptions.workerSrc =
                        "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";
                    resolve();
                };
                script.onerror = reject;
                document.head.appendChild(script);
            });
            pdfjsLib = window.pdfjsLib;
        }

        const arrayBuffer = await selectedFile.arrayBuffer();
        const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

        let html = "<div class='pdf-html'>";
        let buffer = ""; // to collect paragraph text

        for (let p = 1; p <= pdf.numPages; p++) {
            const page = await pdf.getPage(p);
            const content = await page.getTextContent();

            html += `<div class='page' data-page='${p}'>`;

            let lastY = null; // track line changes

            content.items.forEach((item, i) => {
                const text = item.str.trim();
                if (!text) return;

                const fontSize = Math.round(item.height); // Heading detection
                const y = Math.floor(item.transform[5]); // Y axis for line grouping

                const isBullet = /^(\•|\-|\–|\*)/.test(text);

                // Detect new line
                if (lastY !== null && Math.abs(lastY - y) > 6) {
                    if (buffer.trim()) {
                        html += `<p>${buffer.trim()}</p>`;
                        buffer = "";
                    }
                }

                // HEADINGS (PDF usually > 14px)
                if (fontSize >= 14 && !isBullet && text.length <= 60) {
                    if (buffer.trim()) {
                        html += `<p>${buffer.trim()}</p>`;
                        buffer = "";
                    }
                    html += `<h3>${text}</h3>`;
                }

                // BULLET LIST
                else if (isBullet) {
                    if (!html.endsWith("<ul>")) {
                        if (buffer.trim()) html += `<p>${buffer.trim()}</p>`;
                        buffer = "";
                        html += "<ul>";
                    }
                    html += `<li>${text.replace(/^(\•|\-|\–|\*)/, "").trim()}</li>`;
                }

                // NORMAL PARAGRAPH CONTENT
                else {
                    buffer += text + " ";
                }

                lastY = y;
            });

            // Close leftover text in buffer
            if (buffer.trim()) {
                html += `<p>${buffer.trim()}</p>`;
                buffer = "";
            }

            // Close <ul> if still open
            if (html.endsWith("</li>")) {
                html += "</ul>";
            }

            html += "</div>"; // page end
        }

        html += "</div>";
        return html;
    };

    const convertWordToHtml = async () => {
        const arrayBuffer = await selectedFile.arrayBuffer();

        const result = await mammoth.convertToHtml({ arrayBuffer });
        console.log('Conversion result:', result);

        if (result.messages && result.messages.length > 0) {
            console.warn('Conversion warnings:', result.messages);
        }

        return `<div class="word-content">${result.value}</div>`;
    };

    const addDocumentStyles = () => {
        const styles = `
        <style>
          .pdf-content, .word-content {
            font-family: Arial, sans-serif;
            line-height: 1.6;
            color: #333;
          }
          .page {
            margin-bottom: 30px;
            padding: 20px;
            border-bottom: 1px solid #eee;
          }
          .page h3 {
            color: #666;
            font-size: 18px;
            margin-bottom: 15px;
            border-bottom: 2px solid #007bff;
            padding-bottom: 5px;
          }
          .page h4 {
            color: #333;
            font-size: 16px;
            font-weight: bold;
            margin: 15px 0 10px 0;
          }
          .page p {
            margin-bottom: 10px;
            text-align: justify;
          }
          .word-content h1, .word-content h2, .word-content h3 {
            color: #333;
            margin-top: 20px;
            margin-bottom: 10px;
          }
          .word-content p {
            margin-bottom: 10px;
            text-align: justify;
          }
          .word-content ul, .word-content ol {
            margin: 10px 0;
            padding-left: 30px;
          }
          .word-content table {
            border-collapse: collapse;
            width: 100%;
            margin: 15px 0;
          }
          .word-content th, .word-content td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: left;
          }
          .word-content th {
            background-color: #f2f2f2;
            font-weight: bold;
          }
        </style>
      `;
        return styles;
    };

    const resetConverter = () => {
        setSelectedFile(null);
        setExtractedText('');
        setError('');
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    //<---------------------end---------------------------->

    const saveDoc = async () => {
        //setCreateModal(false);

        setIsLoading(true);
        let payload = formData;
        if (modalFrom === 'attach') {
            payload = { ...formData, documentable_id: srId }
        } else if (details_doc) {
            payload = { ...formData, documentable_id: srId, documentable_type: 'service_recovery' }

        }
        // console.log("formData==>", payload);
        try {
            const res = await withRFSToken.post("document/add-update", payload);
            if (res.data.response_code == 200) {
                setCreateModal(false)

                // window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                toast.success(res.data.response_msg);
                onSave()

            } else {

                toast.error(res.data.response_msg);
            }
            setIsLoading(false);
        } catch (error) {
            console.error('Error sending request:', error);
            setIsLoading(false);
        }
    }

    const formatOptionLabel = ({ label, imageUrl }, { context }) => {
        const truncateLabel = (label) => {
            if (label.length <= 3) return label;
            return label.slice(0, 3) + '...';
        };

        const displayLabel = context === 'value' ? truncateLabel(label) : label;

        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <img src={Docmnt} alt={label} style={{ width: 30, height: 30, objectFit: 'cover', borderRadius: 4, marginRight: 10 }} />
                <span>{displayLabel}</span>
            </div>
        );
    };

    const closeModal = () => {
        setCreateModal(false)
        onclose(false)
    }

    return (
        <>
            {isLoading &&
                <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
            }
            <Modal show={createModal} onHide={closeModal} className='add_task_modal' centered size="xl">
                <Modal.Header closeButton >
                    <h6>
                        <FontAwesomeIcon icon={faFileAlt} className="me-2" />
                        {createPos === 'N' ? 'Create new' : 'Edit'} document
                    </h6>
                </Modal.Header>
                <Modal.Body>
                    <Form className='add_taskForm'>
                        <Row>
                            <Form.Group as={Col} md="6" controlId="validationCustom01" className='mb-3'>
                                <Form.Label>Document Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    placeholder="Document Name"
                                    value={formData.name}
                                    onChange={(e) => handleChange('name', e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group as={Col} md="6" controlId="validationCustom01" className='mb-3'>
                                <Form.Label>Use Template</Form.Label>
                                <Select
                                    options={templateData}
                                    value={templateData?.find(option => option.value == formData?.template_id) || ''}
                                    onChange={selected => handleChange('template_id', selected ? selected.value : '')}
                                    placeholder="Select template"
                                    isClearable
                                />
                            </Form.Group>
                            {!details_doc &&
                                <Form.Group as={Col} md="6" controlId="validationCustom01" className='mb-3'>
                                    <Form.Label>Version</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="version"
                                        placeholder="1.0"
                                        value={formData.version}
                                        onChange={(e) => handleChange('version', e.target.value)}
                                    />
                                </Form.Group>
                            }
                        </Row>
                        <Row>
                            <Form.Group as={Col} md="6" controlId="validationCustom01" className='mb-3'>

                                {modalFrom !== 'attach' || !details_doc &&
                                    <>
                                        <Form.Label>Use Template</Form.Label>
                                        <Select
                                            options={templateData}
                                            value={templateData?.find(option => option.value == formData?.template_id) || ''}
                                            onChange={selected => handleChange('template_id', selected ? selected.value : '')}
                                            placeholder="Select template"
                                            isClearable
                                        />
                                        <Form.Label>Assign to Recovery</Form.Label>
                                        <Select
                                            options={awbList}
                                            value={awbList?.find(option => option.value == formData?.documentable_id) || null}
                                            onChange={selected => setFormData({
                                                ...formData,
                                                documentable_id: selected?.value,
                                                documentable_type: selected?.documentable_type,
                                            })}
                                            placeholder="Select AWB"
                                        />
                                    </>
                                }
                            </Form.Group>
                            {!details_doc &&
                                <>
                                    <Form.Group as={Col} md="3" controlId="validationCustom01" className='mb-3'>
                                        <Form.Label>Attached File</Form.Label>
                                        <Select
                                            isMulti
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            options={imageOptions}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            value={imageOptions?.filter(opt => formData.doc_upload?.includes(opt.value))}
                                            onChange={(selectedOptions) => {
                                                const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                                                handleChange('doc_upload', values);
                                            }}
                                            placeholder="Select files"
                                            formatOptionLabel={formatOptionLabel}
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} md="3" controlId="validationCustom01" className='mb-3'>
                                        <Form.Label></Form.Label>
                                        <div className="dropfile dropfiles" style={{ display: 'flex', alignItems: 'center', padding: '8px', border: '1px dashed #ccc', borderRadius: '5px', }} onDrop={handleDrop} onDragOver={handleDragOver} >
                                            <h3 style={{ margin: 0, fontSize: '14px' }}>Drag and drop files here</h3>
                                            <button className='btn btn-primary drpbtn' style={{ padding: '4px 8px', fontSize: '12px', height: '30px', lineHeight: '20px' }} onClick={handleBrowseFiles}>
                                                Browse
                                            </button>
                                            <input
                                                type="file" ref={fileInputRef}
                                                onChange={handleFileChange} style={{ display: 'none' }}
                                                accept=".doc,.docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword"
                                                multiple
                                            />
                                        </div>
                                        {files?.map((file, index) => {
                                            const fileName = typeof file.name === "string" ? file.name : "";
                                            const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                            const extension = fileName?.split(".").pop()?.toLowerCase();
                                            return (
                                                <div key={index} className={`img-thumbnail ${selectedKeys.includes(index) ? 'primaryimg' : ''}`} onClick={() => handleImageSelect(index, file)}>
                                                    {["jpeg", "jpg", "png", "webp"].includes(extension)
                                                        ? (
                                                            <>
                                                                <img
                                                                    src={URL.createObjectURL(file)}
                                                                    alt="Preview"
                                                                    style={{
                                                                        maxWidth: "30px",
                                                                        maxHeight: "30px",
                                                                        marginRight: "5px",
                                                                    }}
                                                                />
                                                                <span>
                                                                    {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 40)}... .${extension}`}
                                                                </span>
                                                            </>
                                                        ) : (
                                                            <span className="d-flex align-items-center">
                                                                <img src={Docmnt} style={{
                                                                    maxWidth: "30px",
                                                                    maxHeight: "30px",
                                                                    marginRight: "5px",
                                                                }} />
                                                                <span>{fileName}</span>
                                                            </span>
                                                        )}
                                                    <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                                </div>
                                            )
                                        })}
                                    </Form.Group>
                                    <div className='ship_head' ></div>
                                    <Col sm={6}>
                                        <Form.Group as={Row} className="mb-2" controlId="publish">
                                            <Form.Label column sm="3">
                                                Publish <span title="Info"></span>
                                            </Form.Label>
                                            <Col sm="8" className="d-flex align-items-center">
                                                <Form.Check
                                                    inline
                                                    label="Yes"
                                                    name="is_publish"
                                                    type="radio"
                                                    value={1}
                                                    checked={formData.is_publish === 1}
                                                    onChange={(e) => handleChange('is_publish', 1)}
                                                />

                                                <div className="d-inline-flex align-items-center">
                                                    <Form.Check
                                                        inline
                                                        label="No"
                                                        name="is_publish"
                                                        type="radio"
                                                        value={0}
                                                        className='me-1'
                                                        checked={formData.is_publish === 0}
                                                        onChange={(e) => handleChange('is_publish', 0)}
                                                    />
                                                    {formData.is_publish === 1 && (
                                                        <span className="text-danger small ms-0">
                                                            Turning off will invalidate existing link!
                                                        </span>
                                                    )}
                                                </div>
                                            </Col>
                                        </Form.Group>

                                        {formData.is_publish === 1 && (
                                            <>
                                                <Form.Group as={Row} className="mb-2" controlId="requiresLogin">
                                                    <Form.Label column sm="3">
                                                        Requires login <span title="Info"></span>
                                                    </Form.Label>
                                                    <Col sm="8">
                                                        <Form.Check
                                                            inline
                                                            label="Yes"
                                                            name="requires_login"
                                                            type="radio"
                                                            value={1}
                                                            checked={formData.requires_login === 1}
                                                            onChange={(e) => handleChange('requires_login', 1)}
                                                        />
                                                        <Form.Check
                                                            inline
                                                            label="No"
                                                            name="requires_login"
                                                            type="radio"
                                                            value={0}
                                                            checked={formData.requires_login === 0}
                                                            onChange={(e) => handleChange('requires_login', 0)}
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} className="mb-2 align-items-baseline" controlId="announcement">
                                                    <Form.Label column sm="3">Announcement <span title="Info"></span></Form.Label>
                                                    <Col sm="4">
                                                        <Form.Check
                                                            inline
                                                            label="Yes"
                                                            name="announcement"
                                                            type="radio"
                                                            value={1}
                                                            checked={formData.announcement === 1}
                                                            onChange={(e) => handleChange('announcement', 1)}
                                                        />
                                                        <Form.Check
                                                            inline
                                                            label="No"
                                                            name="announcement"
                                                            type="radio"
                                                            value={0}
                                                            className=''
                                                            checked={formData.announcement === 0}
                                                            onChange={(e) => handleChange('announcement', 0)}
                                                        />
                                                    </Col>
                                                    {formData.announcement === 1 && (
                                                        <>
                                                            <Form.Label column sm="3">No. of Days <span title="Info"></span></Form.Label>
                                                            <Col sm={2}>
                                                                <Form.Control
                                                                    type="number"
                                                                    value={formData.announcement_days || 30}
                                                                    onChange={(e) => handleChange('announcement_days', Number(e.target.value))}
                                                                />
                                                            </Col>
                                                        </>
                                                    )}
                                                </Form.Group>

                                                {formData.announcement == 0 &&
                                                    <Form.Group as={Row} className="mb-3" controlId="readSign">
                                                        <Form.Label column sm={3}>
                                                            Read & Sign <span title="Info"></span>
                                                        </Form.Label>

                                                        {/* Radio buttons */}
                                                        <Col sm={5}>
                                                            <Form.Check
                                                                inline
                                                                label="Yes"
                                                                name="read_and_sign"
                                                                type="radio"
                                                                value={1}
                                                                checked={formData.read_and_sign === 1}
                                                                onChange={(e) => handleChange('read_and_sign', 1)}
                                                            />
                                                            <Form.Check
                                                                inline
                                                                label="No"
                                                                name="read_and_sign"
                                                                type="radio"
                                                                value={0}
                                                                checked={formData.read_and_sign === 0}
                                                                className='me-1'
                                                                onChange={(e) => handleChange('read_and_sign', 0)}
                                                            />
                                                        </Col>


                                                        {formData.read_and_sign === 1 && (
                                                            <Col sm={3}>
                                                                <Select
                                                                    options={readSignType}
                                                                    value={readSignType.find(option => option.value === formData.read_and_sign_reminder) || null}
                                                                    onChange={(selected) =>
                                                                        handleChange('read_and_sign_reminder', selected ? selected.value : '')
                                                                    }
                                                                    placeholder="Select"
                                                                    isClearable
                                                                    className='read_sign_select'
                                                                />
                                                            </Col>
                                                        )}
                                                    </Form.Group>
                                                }
                                            </>
                                        )}

                                    </Col>
                                    {formData.is_publish === 1 && (
                                        <>
                                            <Col sm={6}>
                                                <Form.Group as={Row} className="mb-3" controlId="publishLink">
                                                    <Form.Label column sm="3">Publish Link:</Form.Label>
                                                    <Col sm="9" className="d-flex">
                                                        <Form.Control
                                                            type="text"
                                                            value={formData.publish_link}
                                                            onChange={(e) => setFormData({ ...formData, publish_link: e.target.value })}
                                                        />
                                                        <button type="button" className="btn btn-primary ms-2 publish_link_cpy">Copy</button>
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} className="mb-3" controlId="formPublishFor">
                                                    <Form.Label column sm="3">Publish For:</Form.Label>
                                                    <Col sm="8">
                                                        <Form.Check
                                                            inline
                                                            label="Private"
                                                            name="publish_for"
                                                            type="radio"
                                                            value="private"
                                                            checked={formData.publish_for === 'private'}
                                                            onChange={(e) => handleChange('publish_for', e.target.value)}
                                                        />
                                                        <Form.Check
                                                            inline
                                                            label="Departments"
                                                            name="publish_for"
                                                            type="radio"
                                                            value="departments"
                                                            checked={formData.publish_for === 'departments'}
                                                            onChange={(e) => handleChange('publish_for', e.target.value)}
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                {formData.publish_for === 'departments' && (
                                                    <Form.Group as={Row} className="mb-3" controlId="formPlaintextDepartment">
                                                        <Form.Label column sm="3">Department</Form.Label>
                                                        <Col sm="9">
                                                            <Select
                                                                isMulti
                                                                options={departmentList}
                                                                value={departmentList.filter(option =>
                                                                    formData.department_id.includes(option.value)
                                                                )}
                                                                onChange={selected =>
                                                                    handleChange(
                                                                        'department_id',
                                                                        selected ? selected.map(opt => opt.value) : []
                                                                    )
                                                                }
                                                                placeholder="Select departments"
                                                                isClearable
                                                            />
                                                        </Col>
                                                    </Form.Group>
                                                )}
                                            </Col>
                                        </>
                                    )}

                                    <div className='ship_head' ></div>

                                    <Col>
                                        <Form.Group as={Col} md="12" controlId="validationCustom01">
                                            <Form.Label>Upload Document</Form.Label>
                                            <div className="dropfile">
                                                <h3>Drag and drop files here</h3>
                                                <button
                                                    className='btn btn-primary drpbtn'
                                                    type="button"
                                                    onClick={handleBrowseFiles1}
                                                >
                                                    Browse Files
                                                </button>
                                                <span>Maximum file size 4 MB</span>
                                                <input
                                                    type="file"
                                                    ref={fileInputRef1}
                                                    onChange={handleFileSelect}
                                                    accept=".pdf,.doc,.docx,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword"
                                                    style={{ display: 'none' }}
                                                />
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group as={Col} md="12" controlId="validationCustom01">
                                            <Form.Label>Upload Document Preview</Form.Label>

                                            <div
                                                className="dropfile"
                                                style={{
                                                    height: '117px',
                                                    border: '1px dashed #ccc',
                                                    borderRadius: '6px',
                                                    backgroundColor: '#f8f9fa',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    flexDirection: 'column',
                                                    padding: '20px'
                                                }}>
                                                {/* <FontAwesomeIcon icon={faTrash} className='upld_doc_ddlt' /> */}
                                                {selectedFile ? (
                                                    <div style={{ textAlign: 'center' }}>
                                                        <div style={{ marginBottom: '10px', fontSize: '40px' }}>
                                                            {selectedFile.name.toLowerCase().endsWith('.pdf') ? '📄' : '📝'}
                                                        </div>
                                                        <div style={{ fontWeight: '600', fontSize: '14px', marginBottom: '5px' }}>
                                                            {selectedFile.name}
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: '#666' }}>
                                                            {(selectedFile.size / 1024).toFixed(1)} KB
                                                        </div>
                                                        <FontAwesomeIcon icon={faTrash} className='upld_doc_ddlt' onClick={resetConverter} />
                                                    </div>

                                                ) : (
                                                    <div style={{ textAlign: 'center', color: '#999' }}>
                                                        <div style={{ fontSize: '40px', marginBottom: '10px' }}>📄</div>
                                                        <span>No file selected</span>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="mt-3 d-flex justify-content-end gap-2">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={convertDocumentToText}
                                                    disabled={!selectedFile}
                                                >
                                                    Convert for Publication
                                                </button>
                                            </div>
                                        </Form.Group>
                                    </Col>
                                </>
                            }

                            <Col md="12">
                                <div className='edithtml' >
                                    <MessageBox
                                        value={formData.content || ''}
                                        onMessageChange={content => handleChange('content', content)}
                                    />

                                </div>
                            </Col>

                        </Row>

                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-100 mx-auto are_bottom justify-content-center'>
                        <Button variant="primary" onClick={() => saveDoc()}>
                            Save
                        </Button>

                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default CreateDoc